// progress-seed.ts — the initial progress state for the real programme.
//
// Fresh start: nothing completed, no current step pinned. The selectors resolve
// the first module of Course 1 (ACT I) and its first lesson as the active step,
// so the user begins at the very beginning. Clearing progress in Settings →
// Privacy returns here.

import type { ProgressState } from '@/services/progress';

export const PROGRESS_SEED: ProgressState = {
  version: 2,
  completedSteps: [],
  completedModules: [],
  currentStepId: null,
  lastRoute: 'recovery',
  positions: {},
  reflections: {},
  favourites: [],
  mood: null,
  dismissedTestimonials: [],
  devMode: false,
  fontScale: 1,
  completedAt: {},
  careTriggered: false,
  careActions: [],
  inAppJournaling: false,
  journalingChoiceMade: false,
  activeProgramme: 'main',
  onboardingDone: false,
  onboarding: { reached: 0, completedAt: null },
  morningAnchorTime: null,
  calmPracticeTime: null,
  programmeReminder: null,
  reminderNudgeDismissed: false,
  trialEndedSeenAt: null,
  demographicsCheckinDone: false,
  guide: {
    recentQuoteIds: {},
    seen: {},
    boundariesShown: [],
    lastReturnHandled: null,
    lastGuideMessageAt: null,
    impressions: [],
  },
  dailyCapacity: {},
  presenceDays: [],
  practisedSteps: [],
  intentions: {},
  paused: null,
  actBoundariesSeen: [],
  reflectionSkips: [],
  reflectionOwnWay: false,
  guideMasteryDue: false,
  guideOverPacingDue: false,
  reviewMode: false,
  reviewComments: [],
  toolkitAnnounced: [],
  toolkitIntroSeen: false,
  inspireIntroSeen: false,
  chapterCelebration: null,
  encouragement: { sessions: 0, lastFiredSession: 0, lastDay: null },
  lastCheckinSession: null,
  lastResearchCheckinAt: null,
  checkinSnoozeWindow: null,
  checkinSnoozeUntil: null,
  completedCheckinCount: null, // unknown until the server answers — never guess zero
  practiceDays: {},
  userType: null,
  researchConsent: 'unset',
  researchConsentVersion: null,
  termsAcceptedVersion: null,
  chapterFeedbackGiven: [],
  actSurveysGiven: [],
  calmSessionsCount: 0,
  toolUsesCount: 0,
  needsThemes: null,
  fogsResult: null,
  fogsOpenedAt: null,
  fogsOpenedMode: null,
  fogsDismissedBeforeAct1: false,
  fogsActReminderDone: false,
  fogsDoneLocal: false,
};
